import React, { Component } from 'react';
import { Button, Form, Grid, Header, Icon, Modal, Segment, Divider, Dropdown, Label } from 'semantic-ui-react';
import { moveMailFromFolder, deleteMailFromFolder, uploadFile, downloadFile } from '../../utils/rest';
import CKEditor from "react-ckeditor-component";
import Dropzone from 'react-dropzone';
class Compose extends Component {

    constructor(props) {
        super(props);
        this.state = {
            attachment: false
        }
    }
    renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } })

    move = (folder, mailId) => {
        if (this.props.type === "trash" && folder === "trash") {
            deleteMailFromFolder(mailId, {}).then((response) => {
                if (response != null) {
                    this.props.removeFromList();
                    this.props.close();
                }
            })
        }
        else {
            moveMailFromFolder(mailId, { folder: folder }).then((response) => {
                if (response != null) {
                    this.props.removeFromList();
                    this.props.close();
                }
            })
        }
    }

    onDrop = (acceptedFiles) => {
        // do stuff with files…
        const data = new FormData()
        acceptedFiles.forEach(file => {
            data.append('files', file);
        });

        uploadFile(data).then((response) => {
            if (response !== null && response instanceof Array) {
                this.setState({
                    attachment: false
                })
                this.props.addAttachement(response);
            }
        })
    }

    showAttachment = () => {
        this.setState((prevProps) => {
            return {
                attachment: !prevProps.attachment
            }
        })
    }

    downloadFiles = (id) => {
        downloadFile(id).then((response) => {
            if (response !== null) {
                let disposition = response.request.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    let matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        let filename = matches[1].replace(/['"]/g, '');
                        if (typeof window.navigator.msSaveBlob !== 'undefined') {
                            // IE workaround for "HTML7007: One or more blob URLs were 
                            // revoked by closing the blob for which they were created. 
                            // These URLs will no longer resolve as the data backing 
                            // the URL has been freed."
                            window.navigator.msSaveBlob(new Blob([response.data]), filename);
                        } else {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', filename);
                            document.body.appendChild(link);
                            link.click();
                        }
                    }
                }
            }
        })
    }

    content = (item, index) => {
        if (index === 0 && this.props.type === "draft") {
            return (
                <Segment key={index}>
                    {this.composeContent()}
                </Segment>
            )
        }
        return (
            <Segment key={index}>
                <Form.Group widths={2}>
                    <Form.Field inline>
                        <label>From: {item.msgUsrNameFrom}</label>
                    </Form.Field>
                    {item.msgCrpRefName != "" && <Form.Field inline>
                        <label>Corporate: {item.msgCrpRefName}</label>
                    </Form.Field>}
                </Form.Group >
                <Form.Group>
                    <Form.Field>
                        <label>To: {item.msgUsrNameTo}</label>
                    </Form.Field>
                </Form.Group >
                {
                    (() => {
                        if (item.msgUsrNameCC && item.msgUsrNameCC.length > 0) {
                            return (
                                <Form.Group>
                                    <Form.Field>
                                        <label>CC: {item.msgUsrNameCC}</label>
                                    </Form.Field>
                                </Form.Group >
                            )
                        }
                    })()
                }
                <Form.Group>
                    <Form.Field inline>
                        <label>Subject: {item.msgSubject}</label>
                    </Form.Field>
                </Form.Group >
                <Form.Group >
                    <Form.Field>
                        <Label.Group tag>
                            {
                                (() => {
                                    return item.msaAttachment && item.msaAttachment.map((attachment, index) => {
                                        return (
                                            <Label as='a' key={index} onClick={() => { this.downloadFiles(attachment.id) }}>
                                                {attachment.filename}
                                            </Label>
                                        )
                                    })
                                })()
                            }
                        </Label.Group >
                    </Form.Field>
                </Form.Group >
                <Divider />
                <Form.Field>
                    <div className="small-font">
                        {this.renderHTML(item.msgBody)}
                    </div>
                </Form.Field>
            </Segment>
        )

    }

    compose = () => {
        return (
            <Segment.Group>
                <Segment>
                    <Header as='h5'>{this.props.t("compose.email")}</Header>
                </Segment>
                <Segment>
                    {this.composeContent()}
                </Segment>
            </Segment.Group>
        )
    }


    draft = () => {
        return (
            <div>
                <Segment>
                    <Header as='h5'>Draft</Header>
                </Segment>
                <Segment>
                    {this.composeContent()}
                </Segment>
            </div>
        )
    }

    composeContent = () => {
        return (
            <div>
                <Form.Field>
                    <Dropdown className="fluid" placeholder={this.props.t("to")} search multiple selection options={this.props.userList} name="msgUsrRefIdTo" value={this.props.sendMail.msgUsrRefIdTo} onChange={this.props.handleChange} />
                </Form.Field>
                <Form.Group widths={2}>
                    <Form.Field>
                        <Dropdown placeholder={this.props.t("cc")} search multiple selection options={this.props.userList} value={this.props.sendMail.msgUsrRefIdCC} name="msgUsrRefIdCC" onChange={this.props.handleChange} />
                    </Form.Field>
                    <Form.Field>
                        <Dropdown placeholder={this.props.t("bcc")} search multiple selection options={this.props.userList} value={this.props.sendMail.msgUsrRefIdBCC} name="msgUsrRefIdBCC" onChange={this.props.handleChange} />
                    </Form.Field>
                </Form.Group>
                <Form.Field>
                    <Form.Input placeholder="Subject" name="msgSubject" value={this.props.sendMail.msgSubject} onChange={this.props.handleChange} />
                </Form.Field>
                <Form.Field style={{ display: this.state.attachment ? "block" : "none" }}>
                    <Dropzone style={{
                        position: "relative",
                        height: "50px",
                        borderWidth: "2px",
                        borderColor: "rgb(102, 102, 102)",
                        borderStyle: "dashed",
                        borderRadius: "5px",
                        textAlign: "center"
                    }} onDrop={(files) => this.onDrop(files)}>
                        <br></br>Try dropping some files here, or click to select files to upload.
                    </Dropzone>
                </Form.Field>
                <Form.Field>
                    <Label.Group >
                        {
                            (() => {
                                return this.props.sendMail.msaAttachment && this.props.sendMail.msaAttachment.map((attachment, index) => {
                                    return (
                                        <Label as='a' key={index}>
                                            <Icon name='download' onClick={() => { this.downloadFiles(attachment.id) }} />
                                            {attachment.filename}
                                            <Icon name='delete' onClick={() => { this.props.deleteAttachment(attachment.id) }} />
                                        </Label>
                                    )
                                })
                            })()
                        }
                    </Label.Group >
                </Form.Field>
                <Form.Field>
                    <CKEditor
                        activeClass="p10"
                        name="msgBody"
                        content={this.props.sendMail.msgBody}
                        events={{
                            "change": this.props.onContentChange
                        }}
                        config={{
                            versionCheck: false // Disable version checking here
                         }}
                    />
                </Form.Field>
            </div>
        )
    }
    replyOrFwd = () => {
        if (!this.props.read) {
            return (
                <Segment.Group>
                    <Segment>
                        <Header as='h5'> {this.props.title}</Header>
                    </Segment>
                    <Segment>
                        {this.composeContent()}
                    </Segment>
                </Segment.Group>
            )
        }
    }

    render() {
        const mail = (
            () => {
                if (this.props.read || this.props.mailDetails.length > 0) {

                    return (
                        <div>
                            {this.replyOrFwd()}
                            {
                                this.props.mailDetails.map((item, index) => {
                                    return (
                                        <Segment.Group style={{ marginTop: 15 }} key={index}>
                                            {this.content(item, index)}
                                        </Segment.Group>
                                    )
                                })
                            }
                        </div>
                    )
                } else {
                    return this.compose();
                }
            }
        )()
        return (
            <Modal open={this.props.toggleCompose} onClose={this.props.close} closeOnEscape={this.props.read}
                closeOnDimmerClick={this.props.read} closeIcon  /*closeIcon={!this.props.read}*/ >
                <Modal.Content size='large' >
                    <Modal.Description>
                        <Form>
                            <Grid columns={2}>
                                <Grid.Column width={14}>
                                    {mail}
                                </Grid.Column>
                                <Grid.Column width={2}>
                                    <Segment.Group>
                                        <Segment className='blue inverted' textAlign="center" disabled={this.props.read && this.props.type !== "draft"}
                                            onClick={() => {
                                                if (this.props.read && this.props.type !== "draft") { return } else { this.props.handleSubmit() }
                                            }} style={{ cursor: "pointer" }}>
                                            <Header as='h5' className='white inverted' >
                                                Send
                                             </Header>
                                        </Segment>
                                        <Segment textAlign="center">
                                            <Button inverted className='blue icon margin-bottom-5' data-tooltip='Save as Draft'
                                                data-position='left center' disabled={this.props.read && this.props.type !== "draft"}
                                                onClick={() => { this.props.handleSubmit({ type: "draft" }) }} >
                                                <Icon className='firstdraft' />
                                            </Button>
                                            <Button
                                                className='icon margin-bottom-5'
                                                data-tooltip='Reply'
                                                data-position='left center'
                                                disabled={!this.props.read || this.props.type === "draft"}
                                                onClick={() => { this.props.replyOrFwd("Reply") }}
                                            >
                                                <Icon className='reply' />
                                            </Button>
                                            <Button
                                                className='icon margin-bottom-5'
                                                data-tooltip='Reply All'
                                                data-position='left center'
                                                disabled={!this.props.read || this.props.type === "draft"}
                                                onClick={() => { this.props.replyOrFwd("Reply All") }}>
                                                <Icon className='reply all' />
                                            </Button>
                                            <Button
                                                className='icon margin-bottom-5'
                                                data-tooltip='Forward'
                                                data-position='left center'
                                                disabled={!this.props.read || this.props.type === "draft"}
                                                onClick={() => { this.props.replyOrFwd("Fwd") }}>
                                                <Icon className='forward' />
                                            </Button>
                                            <Button
                                                inverted
                                                className='blue icon margin-bottom-5'
                                                data-tooltip='Attach a File'
                                                data-position='left center'
                                                disabled={this.props.read && this.props.type !== "draft"}
                                                onClick={() => { this.showAttachment() }}>
                                                <Icon className='paperclip' />
                                            </Button>
                                            <Button
                                                className='icon margin-bottom-5'
                                                data-tooltip='Keep in Important Folder'
                                                data-position='left center'
                                                disabled={!this.props.read || this.props.type === "important" || this.props.type === "draft"}
                                                onClick={() => { this.move("important", this.props.mailId) }} >
                                                <Icon className='warning' />
                                            </Button>
                                            <Button
                                                className='icon margin-bottom-5'
                                                data-tooltip='Keep in Save Folder'
                                                data-position='left center'
                                                disabled={!this.props.read || this.props.type === "saved" || this.props.type === "draft"}
                                                onClick={() => { this.move("saved", this.props.mailId) }} >
                                                <Icon className='save' />
                                            </Button>
                                            <Button className='red icon margin-bottom-5'
                                                data-tooltip='Trash'
                                                data-position='left center'
                                                disabled={!this.props.read}
                                                onClick={() => { this.move("trash", this.props.mailId) }} >
                                                <Icon className='trash' />
                                            </Button>
                                        </Segment>
                                        <Segment className='red inverted' textAlign="center" style={{ cursor: "pointer" }} onClick={this.props.close} >
                                            <Header as="h5" className='white inverted'>
                                                {this.props.read ? "Close" : "Discard"}
                                            </Header>
                                        </Segment>
                                    </Segment.Group>
                                </Grid.Column>
                            </Grid>
                        </Form>
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        );
    }
}
export default Compose;


// WEBPACK FOOTER //
// ./src/app/ui/mails/Compose.js